import { useRecoilState, SetterOrUpdater } from 'recoil';

import {
  dfiReportBestPracticeResponseIsEditingState,
  dfiReportInfoOnLateResponseIsEditingState,
} from 'store';
import { ReviewResponse } from '../types';

export const useEditingReviewState = (
  responseType: ReviewResponse
): [boolean, SetterOrUpdater<boolean>] => {
  const bestPracticeResponseIsEditing = useRecoilState(
    dfiReportBestPracticeResponseIsEditingState
  );

  const infoOnLateResponseIsEditing = useRecoilState(
    dfiReportInfoOnLateResponseIsEditingState
  );

  return responseType === ReviewResponse.BestPracticeResponse
    ? bestPracticeResponseIsEditing
    : infoOnLateResponseIsEditing;
};
